// src/web3/connectors.js
import { initializeConnector } from '@web3-react/core';
import { MetaMask } from '@web3-react/metamask';
import { CoinbaseWallet } from '@web3-react/coinbase-wallet';
import { WalletConnect } from '@web3-react/walletconnect-v2';

// === RPC URLs ===
const BASE_SEPOLIA_RPC   = (process.env.REACT_APP_BASE_RPC_URL || 'https://sepolia.base.org').trim();
const BASE_MAINNET_RPC   = (process.env.REACT_APP_BASE_MAINNET_RPC_URL || 'https://mainnet.base.org').trim();

// === WalletConnect Project ID ===
const WC_PROJECT_ID = process.env.REACT_APP_WC_PROJECT_ID;

// === Целевая сеть (по умолчанию — Base Sepolia) ===
const CHAIN_ID   = parseInt(process.env.REACT_APP_CHAIN_ID || '84532', 10);
const IS_MAINNET = CHAIN_ID === 8453;

// === Опциональные сети ===
const OPTIONAL_CHAINS = IS_MAINNET ? [84532] : [8453];

const getOrigin = () => (typeof window === 'undefined' ? 'http://localhost:3000' : window.location.origin);
const getRpcUrlForCoinbase = () => (IS_MAINNET ? BASE_MAINNET_RPC : BASE_SEPOLIA_RPC);

function buildConnectors() {
  const pairs = [];
  const instances = {};

  // === MetaMask ===
  const [metaMask, metaMaskHooks] = initializeConnector(
    (actions) => new MetaMask({ actions, options: { mustBeMetaMask: false } })
  );
  pairs.push([metaMask, metaMaskHooks]);
  instances.metaMask = metaMask;

  // === Coinbase Wallet ===
  const [coinbaseWallet, coinbaseHooks] = initializeConnector(
    (actions) =>
      new CoinbaseWallet({
        actions,
        options: {
          url: getRpcUrlForCoinbase(),
          appName: 'PGT Tickets',
          darkMode: true,
        },
      })
  );
  pairs.push([coinbaseWallet, coinbaseHooks]);
  instances.coinbaseWallet = coinbaseWallet;

  // === WalletConnect v2 ===
  if (WC_PROJECT_ID) {
    const [walletConnect, walletConnectHooks] = initializeConnector(
      (actions) =>
        new WalletConnect({
          actions,
          options: {
            projectId: WC_PROJECT_ID,
            chains: [CHAIN_ID],
            optionalChains: OPTIONAL_CHAINS,
            showQrModal: true,
            rpcMap: {
              84532: BASE_SEPOLIA_RPC,
              8453: BASE_MAINNET_RPC,
            },
            metadata: {
              name: 'PGT Tickets',
              description: 'Event tickets dApp',
              url: getOrigin(),
              icons: [`${getOrigin()}/logo192.png`],
            },
          },
        })
    );
    pairs.push([walletConnect, walletConnectHooks]);
    instances.walletConnect = walletConnect;
  } else {
    console.warn('[WalletConnect] REACT_APP_WC_PROJECT_ID is missing; WC connector not added.');
  }

  return { pairs, instances };
}

// === Singleton для HMR ===
const GLOBAL_KEY = '__WEB3_CONNECTORS_SINGLETON__';
const singleton =
  typeof window !== 'undefined'
    ? (window[GLOBAL_KEY] ||= buildConnectors())
    : buildConnectors();

export const connectors     = singleton.pairs;
export const metaMask       = singleton.instances.metaMask;
export const coinbaseWallet = singleton.instances.coinbaseWallet;
export const walletConnect  = singleton.instances.walletConnect || null;
